import icons from '@/styles/icons';
import theme from '@/styles/theme';
import createTcComponents from '@tc/ui-component/src/';
export default function addTcComponents(_Vue) {
    const tcComponents = createTcComponents(theme, icons);
    _Vue.use(tcComponents);
    return { tcComponents };
}
